import { apiFetch } from '@ami/react/core';
import QuotePricingInput from './entities/quotePricingInput';
const { AbortController } = window;
import { QuotePricingOutput } from './entities/quotePricingOutput';

const _baseEndPoint = 'quotes/pricing';
let controller = null;

export default {
  calculatePricing: async (input) => {
    if (controller) {
      controller.abort();
    }

    controller = new AbortController();
    const signal = controller.signal;
    var model = null;
    var discountsInput = new QuotePricingInput(input);

    await apiFetch(`${_baseEndPoint}`, 'POST', discountsInput, {
      automaticSuccessNotification: false
    }, false, {signal: signal} ).then(
      (response) => (model = new QuotePricingOutput(response))
    ).catch(() => {});
    return model;
  },
};
